import SegmentedControl from '../StartScreen/SegmentedControl';
import {
  setThemePreference,
  ThemePreference,
  useThemePreference,
} from '../../../theme';

const THEME_OPTIONS: { value: ThemePreference; label: string }[] = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

export default function ThemeControl() {
  const preference = useThemePreference();
  return (
    <SegmentedControl
      label="Theme"
      options={THEME_OPTIONS}
      value={preference}
      onChange={setThemePreference}
    />
  );
}
